var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('InitialAvatarIcon',{class:_vm.computedClass,attrs:{"data-testid":"statement-avatar","icon":_vm.iconName,"size":_vm.size}})
}
var staticRenderFns = []

export { render, staticRenderFns }